import { ADD_QUIZ_SESSIONS, ACTIVE_QUIZ_SESSION_CHANGE } from '@instructure/quiz-common';
import { handleQuizSessionResponse, handleQuizSessionResultsResponse, handleSessionItemsResponse, handleSessionItemResultsResponse } from '../api/callHandlers';
import { fetchQuizSession, fetchSessionItems, fetchSessionItemResults, fetchQuizSessionResult } from '../api/quizSessions';
export var newActiveQuizSession = function newActiveQuizSession(activeQuizSessionId) {
  return {
    type: ACTIVE_QUIZ_SESSION_CHANGE,
    payload: activeQuizSessionId
  };
};
export var clearActiveQuizSession = function clearActiveQuizSession() {
  return {
    type: ACTIVE_QUIZ_SESSION_CHANGE,
    payload: null
  };
};
export var addQuizSessions = function addQuizSessions(quizSessions) {
  var payload = Array.isArray(quizSessions) ? quizSessions : [quizSessions];
  return {
    type: ADD_QUIZ_SESSIONS,
    payload: payload
  };
};
export var handleQuizSessionFetch = function handleQuizSessionFetch(dispatch, quizSession) {
  return dispatch([handleQuizSessionResponse(quizSession), newActiveQuizSession(quizSession.id)]);
};
export var getSessionItems = function getSessionItems(quizSessionId) {
  var apiAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fetchSessionItems;
  return function (dispatch) {
    var responseCb = function responseCb(sessionItemsData) {
      return dispatch(handleSessionItemsResponse(sessionItemsData, quizSessionId));
    };
    return apiAction(quizSessionId, responseCb);
  };
};
export var getSessionItemResults = function getSessionItemResults(quizSessionId, quizSessionResultId) {
  var apiAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetchSessionItemResults;
  return function (dispatch) {
    var responseCb = function responseCb(sessionItemResultsData) {
      return dispatch(handleSessionItemResultsResponse(sessionItemResultsData, quizSessionId));
    };
    return apiAction(quizSessionId, quizSessionResultId, responseCb);
  };
};
export function getQuizSessionResult(authoritativeResultId, quizSessionId) {
  var apiAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetchQuizSessionResult;
  return function (dispatch, getState) {
    var responseCb = function responseCb(result) {
      return dispatch(handleQuizSessionResultsResponse([result]));
    };
    return apiAction(quizSessionId, authoritativeResultId, responseCb);
  };
}

// TODO: set callback tracking in fetcher to prevent hitting this again when the quizSession is loaded and graded
// but the sessionItems aren't yet loaded, then remove the throttling functions in results and grading
export function getResultInfo(quizSessionId) {
  var anonymousGrading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var apiAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetchQuizSession;
  var autoRetry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var fetchItems = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return function (dispatch, getState) {
    var getSIResults = function getSIResults(quizSessionData) {
      if (quizSessionData.status !== 'graded') {
        return;
      }
      return dispatch(getSessionItemResults(quizSessionId, quizSessionData.authoritative_result.id));
    };
    var getSIs = function getSIs(quizSessionData) {
      if (quizSessionData.status !== 'graded') {
        return;
      }
      return dispatch(getSessionItems(quizSessionId));
    };
    var responseCb = function responseCb(quizSessionData) {
      if (autoRetry && quizSessionData.status === 'autograding') {
        setTimeout(function () {
          getResultInfo(quizSessionId, anonymousGrading, apiAction, autoRetry, fetchItems)(dispatch, getState);
        }, 2000);
      }
      var promises = [handleQuizSessionFetch(dispatch, quizSessionData)];
      if (fetchItems) {
        promises.push(getSIs(quizSessionData));
        promises.push(getSIResults(quizSessionData));
      }
      return Promise.all(promises);
    };
    return apiAction(quizSessionId, responseCb, {
      anonymousGrading: anonymousGrading
    });
  };
}